import { sqlQuery } from '@/shared/helpers/api';
import { http } from '@/shared/httpWrapper';

export type Topic = {
    identity: string;
    name: string;
    description: string;
};

export type Document = {
    identity: string;
    name: string;
    description: string;
    tags: string | null;
    dateCreated: string;
    dateUpdated: string;
    topicIdentity: string;
    topicName: string;
};

export type DocumentFile = {
    identity: string;
    name: string;
    description: string;
    revision: string;
    attachmentKey: string;
    issuedFor: string | null;
    changes: string | null;
    dateCreated: string;
    dateUpdated: string;
    documentIdentity: string;
    documentName: string;
    topicIdentity: string;
    topicName: string;
};

export async function getTopics(): Promise<Topic[]> {
    return (await sqlQuery(http, {
        query: `
            select t.[identity], t.[name], t.[description]
            from [DocumentationTopic] t
            where t.[isValid] = 1
            and exists (
                select 1
                from [Documentation] d
                where d.topic_id = t.id
                and d.[isValid] = 1
            )
            order by t.[name]
            `
    })).data as Topic[];
}

export async function getTopicDocuments(identity: string): Promise<Document[]> {
    return (await sqlQuery(http, {
        query: `
            select d.[identity], d.[name], d.[description], d.[tags],
                d.[dateCreated], d.[dateUpdated],
                t.[identity] topicIdentity, t.[name] topicName
            from [Documentation] d
            join [DocumentationTopic] t on t.id = d.topic_id
            where d.[isValid] = 1
            and d.[topic] = @topic
            order by d.[name]
            `,
        arguments: {
            topic: identity!
        }
    })).data as Document[];
}

export async function getDocumentFiles(identity: string): Promise<DocumentFile[]> {
    return (await sqlQuery(http, {
        query: `
            select
                f.[identity], f.[name], f.[description],
                f.[revision], f.[attachmentKey],
                f.[issuedFor], f.[changes],
                f.[dateCreated], f.[dateUpdated],
                d.[identity] documentIdentity, d.[name] documentName,
                t.[identity] topicIdentity, t.[name] topicName
            from [DocumentationFile] f
            join [Documentation] d ON d.id = f.document_id
            join [DocumentationTopic] t on t.id = d.topic_id
            where f.[isValid] = 1
            and d.[identity] = @document
            order by f.[dateCreated]
            `,
        arguments: {
            document: identity!
        }
    })).data as DocumentFile[];
}
